/** Server registry (gateway-cloud, R-152) — cloud-tier, already `/users/...` so resolvePath passes through. */
export const serverEndpoints = {
  list: '/users/v1/servers',
  claim: (id: string) => `/users/v1/servers/${id}/claim`,
  status: (id: string) => `/users/v1/servers/${id}/status`,
  refresh: (id: string) => `/users/v1/servers/${id}/refresh`,
  remove: (id: string) => `/users/v1/servers/${id}`,
} as const;
